import { toProductImpression } from "@omni/services/tracking/mappers/productTileProduct.mapper";
import * as TrackingService from "@omni/services/tracking/tracking.service";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/productClick.trackingInfo";

export const track = (trackingInfo: ProductClickTrackingInfo) => {
    const event: AnalyticsEvent<ProductClickTrackingInfo> = {
        event: EventType.ProductClick,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackProductTile = (
    product: Product<ProductFieldSet.ProductTile>,
    list?: string,
    placement?: number
) => {
    const trackingInfo = {
        ...toProductImpression(product),
        list: list,
        placement: placement
    };

    track(trackingInfo);
};
